import { rackBounds, nodeBounds, sceneBounds } from "./geometry"
import { nodeImageUrl, nodeWithLightsImageUrl } from "./assets"

export function normalizeData(vdcData) {
  const clustersById = {}
  const racksByKey = {}
  const nodesById = {}
  const nodeBoundsById = {}
  const rackBoundsByKey = {}

  vdcData.clusters.forEach(function(cluster) {
    clustersById[cluster.id] = cluster
    cluster.racks.forEach(function(rack, rackIndex) {
      racksByKey[rack.id] = { cluster: cluster, rack: rack, rackIndex: rackIndex }
      rackBoundsByKey[rack.id] = rackBounds(rackIndex)
      rack.nodes.forEach(function(node) {
        nodesById[node.id] = node
        nodeBoundsById[node.id] = nodeBounds(rackIndex, node)
      })
    })
  })

  return {
    clustersById: clustersById,
    racksByKey: racksByKey,
    nodesById: nodesById,
    nodeBoundsById: nodeBoundsById,
    rackBoundsByKey: rackBoundsByKey,
  }
}

export function buildSVG(wrapper, data, assets2d) {
  const svgNS = "http://www.w3.org/2000/svg"

  const rackKeys = Object.keys(data.racksByKey)
  const bounds = sceneBounds(rackKeys.length)

  const svg = document.createElementNS(svgNS, "svg")
  svg.setAttribute("class", "vdc2d-svg")
  svg.setAttribute("width", bounds.width)
  svg.setAttribute("height", bounds.height)
  svg.setAttribute("viewBox", "0 0 " + bounds.width + " " + bounds.height)

  const scene = document.createElementNS(svgNS, "g")
  scene.setAttribute("class", "vdc2d-scene")

  const rackLayer = document.createElementNS(svgNS, "g")
  rackLayer.setAttribute("class", "rack-layer")

  const nodeLayer = document.createElementNS(svgNS, "g")
  nodeLayer.setAttribute("class", "node-layer")

  const nodeWithLightsLayer = document.createElementNS(svgNS, "g")
  nodeWithLightsLayer.setAttribute("class", "node-with-lights-layer")
  nodeWithLightsLayer.setAttribute("style", "display: none; pointer-events: none")

  const highlightLayer = document.createElementNS(svgNS, "g")
  highlightLayer.setAttribute("class", "node-highlight-layer")
  highlightLayer.setAttribute("style", "pointer-events: none")

  const outlineLayer = document.createElementNS(svgNS, "g")
  outlineLayer.setAttribute("class", "node-outline-layer")
  outlineLayer.setAttribute("style", "pointer-events: none")

  rackKeys.forEach(function(rackId) {
    const entry = data.racksByKey[rackId]
    const rack = entry.rack
    const rackIndex = entry.rackIndex
    const cluster = entry.cluster
    const rb = rackBounds(rackIndex)

    const rackImg = document.createElementNS(svgNS, "image")
    rackImg.setAttribute("href", assets2d.rack)
    rackImg.setAttribute("x", rb.x)
    rackImg.setAttribute("y", rb.y)
    rackImg.setAttribute("width", rb.width)
    rackImg.setAttribute("height", rb.height)
    rackLayer.appendChild(rackImg)

    rack.nodes.forEach(function(node) {
      const nb = nodeBounds(rackIndex, node)
      const nodeImg = document.createElementNS(svgNS, "image")
      const imageUrl = nodeImageUrl(node, assets2d)
      const withLightsImageUrl = nodeWithLightsImageUrl(node, assets2d)

      nodeImg.setAttribute("preserveAspectRatio", "none")
      nodeImg.setAttribute("href", imageUrl)
      nodeImg.setAttribute("x", nb.x)
      nodeImg.setAttribute("y", nb.y)
      nodeImg.setAttribute("width", nb.width)
      nodeImg.setAttribute("height", nb.height)
      nodeImg.setAttribute("data-node-id", node.id)
      nodeImg.setAttribute("data-rack-index", rackIndex)
      nodeImg.setAttribute("data-cluster-id", cluster.id)
      nodeLayer.appendChild(nodeImg)

      if (withLightsImageUrl != null && withLightsImageUrl !== imageUrl) {
        const nodeWithLightsImg = document.createElementNS(svgNS, "image")
        nodeWithLightsImg.setAttribute("preserveAspectRatio", "none")
        nodeWithLightsImg.setAttribute("href", withLightsImageUrl)
        nodeWithLightsImg.setAttribute("x", nb.x)
        nodeWithLightsImg.setAttribute("y", nb.y)
        nodeWithLightsImg.setAttribute("width", nb.width)
        nodeWithLightsImg.setAttribute("height", nb.height)
        nodeWithLightsImg.setAttribute("data-node-id", node.id)
        nodeWithLightsImg.setAttribute("data-rack-index", rackIndex)
        nodeWithLightsImg.setAttribute("data-cluster-id", cluster.id)
        nodeWithLightsLayer.appendChild(nodeWithLightsImg)
      }
    })
  })

  scene.appendChild(rackLayer)
  scene.appendChild(nodeLayer)
  scene.appendChild(nodeWithLightsLayer)
  scene.appendChild(highlightLayer)
  scene.appendChild(outlineLayer)
  svg.appendChild(scene)

  // Remove loading text
  while (wrapper.firstChild) {
    wrapper.removeChild(wrapper.firstChild)
  }
  wrapper.appendChild(svg)

  return svg
}
